import { BaseButtonProps } from './button';
import cn from 'classnames';
import { ButtonHTMLAttributes, ReactElement } from 'react';

export interface IconButtonProps
  extends Pick<BaseButtonProps, 'variant' | 'variantType' | 'size' | 'disabled' | 'additionalClass'> {
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  icon: ReactElement;
  onClick?: () => void;
  isLoading?: boolean;
  title?: string;
}

const spinnerSize: Record<NonNullable<BaseButtonProps['size']>, string> = {
  sm: '14px',
  md: '16px',
  lg: '20px'
};

export const IconButton = ({
  icon,
  type = 'button',
  disabled,
  isLoading,
  onClick,
  variant = 'light-primary',
  variantType = 'filled',
  size = 'md',
  additionalClass,
  title
}: IconButtonProps) => {
  const buttonClasses = cn(
    'btn btn-icon',
    `btn${variantType === 'outlined' ? '-outline' : ''}-${variant}`,
    {
      'btn-sm': size === 'sm',
      'btn-lg': size === 'lg',
      disabled: disabled || isLoading
    },
    additionalClass
  );

  return (
    <button className={buttonClasses} type={type} onClick={onClick} disabled={disabled || isLoading} title={title}>
      {isLoading ? (
        <span
          className="spinner-border"
          role="status"
          aria-hidden="true"
          style={{ width: spinnerSize[size ?? 'md'], height: spinnerSize[size ?? 'md'] }}
        />
      ) : (
        icon
      )}
    </button>
  );
};
